import { z } from 'zod/v4-mini';

const materialsEndpoint = `${import.meta.env.VITE_BACKEND_URL}/api/materials`;

export const MaterialTypeSchema = z.union([
  z.literal('color_tint'),
  z.literal('floor_texture'),
  z.literal('wall_texture'),
  z.literal('facade_texture'),
]);

export type MaterialType = z.infer<typeof MaterialTypeSchema>;
export type FilterType = 'all' | MaterialType;

export const materialTypes = [
  'color_tint',
  'floor_texture',
  'wall_texture',
  'facade_texture',
] as const;

export const MaterialSchema = z.pipe(
  z.object({
    id: z.string(),
    type: z.array(MaterialTypeSchema).check(z.minLength(1)),
    producer: z.string(),
    collection: z.string(),
    name: z.string(),
    family: z.string(),
    lrv: z.number(),
    rgb: z.array(z.number()),
    lch: z.array(z.number()),
    hex: z.string(),
    colorRanges: z.array(z.string()),
    page: z.number(),
    pageCount: z.number(),
    pagePosition: z.number(),
    textureWidth: z.nullable(z.number()),
    textureHeight: z.nullable(z.number()),
    textureRepeat: z.nullable(z.number()),
    texturePath: z.nullable(z.string()),
    isProMaterial: z.boolean(),
    isUnavailable: z.optional(z.boolean()),
  }),
  z.transform((material) => {
    const imageUrl = `${materialsEndpoint}/${encodeURIComponent(material.id)}`;

    return {
      ...material,
      url: ({ size = '500' } = {}) =>
        material.texturePath ? `${imageUrl}/thumbnail?size=${size}` : undefined,
      seamlessTextureUrl: (dimensions?: { xSize: number; ySize: number }) => {
        if (!material.texturePath) return undefined;
        if (dimensions == null) return `${imageUrl}/texture`;
        return `${imageUrl}/texture?maxSize=${Math.max(dimensions.xSize, dimensions.ySize)}`;
      },
    };
  }),
);

export type Material = z.infer<typeof MaterialSchema>;
